/**
 * Le flux d'événements de la démo — ce qui remplace le SSE de Cyrano.
 *
 * Le cockpit sait déjà tout faire à partir d'événements `conversation` :
 * « Cyrano génère », « Cyrano a lu », « Cyrano écrit… », « nouveau message ».
 * La démo n'a donc RIEN à réimplémenter côté affichage — elle a juste à
 * publier les mêmes événements, dans le même ordre, sur ce bus.
 *
 * `useSSE` s'y abonne à la place d'ouvrir un `EventSource` quand le drapeau
 * est levé (cf `core/hooks/useSSE.ts`). Un seul flux existe côté cockpit
 * (`/api/conversations/events`), donc un seul bus suffit ici.
 */

type Ecouteur = (evenement: unknown) => void;

const ecouteurs = new Set<Ecouteur>();

/** S'abonne au flux. Rend la fonction de désabonnement. */
export function abonner(ecouteur: Ecouteur): () => void {
  ecouteurs.add(ecouteur);
  return () => {
    ecouteurs.delete(ecouteur);
  };
}

/** Publie un événement à tous les abonnés. Un abonné qui lève n'empêche pas
 *  les autres de recevoir — comme un vrai fan-out. */
export function emettre(evenement: unknown): void {
  for (const ecouteur of [...ecouteurs]) {
    try {
      ecouteur(evenement);
    } catch (err) {
      console.error("[démo] un abonné du bus a levé", err);
    }
  }
}

/** Y a-t-il quelqu'un pour écouter ? Sert aux scénarios à ne pas dérouler une
 *  séquence de 20 s dans le vide quand le panneau n'est pas monté. */
export function personneNecoute(): boolean {
  return ecouteurs.size === 0;
}
